import React from 'react'
import { Button, Table, Container, Row, Col, Label, Input } from 'reactstrap'
import '../css/QuoteViewController.css'
import { ContactInformationViewController } from './ContactInformationViewController'
import { EmailModalController } from './modal/EmailModalController'
import { PackagingSlipModalController } from './modal/PackagingSlipModalController'
import { CustomAddonsModalController } from './modal/CustomAddonsModalController'
import { AlertModalModel, errorMessage } from './modal/AlertModalController'
import SimpleDropdown from '../view/DropDownView'
import AddDropDownView from '../view/AddDropDownView'
import DropDownTextField from '../view/DropDownTextField'
import DateTextField from '../view/DateTextField'
import NumberTextField from '../view/NumberTextField'
import {
    getQuote, updateQuote, createQuote,
    getCustomerNames, getContactInfo,
    getAsanteContactInformation,
    getTypes,
    suggestQuoteFromFiles,
} from '../model/request/quotes'
import { updateSigns } from '../model/request/sign'
import { uploadFile } from '../model/request/files'
import { getAddons } from '../model/request/addons'
import { frontEndBaseURL } from '../model/request/url'
import { downloadPDF } from '../model/request/pdf'
import { sendEmail } from '../model/request/email'
import { Sign, SignType, AddonWithOptions } from '../model/Sign'
import { Quote } from '../model/Quote'
import { Account, Roles } from '../model/Account'
import { giveName } from '../model/NamingConvention'
import { formatAsDollarValue, moneyText } from '../model/Formatting'
import { LocalSettings } from '../model/LocalSettings'
import {
    InfoButton,
} from '../view/InfoButton'
import {
    IoIosArrowUp,
    IoIosArrowDown,
} from 'react-icons/io';

/**
 * A width/height field is valid iff it's a plain decimal number and
 * NOTHING else - no trailing garbage like "5.0 Hello world". The
 * previous check (isNaN(parseFloat(x)) || parseFloat(x).toString() !==
 * x.toString()) tried to detect trailing garbage via a round-trip
 * through parseFloat/toString, but that also flags perfectly valid
 * input: parseFloat("6.0").toString() is "6", not "6.0", so a clean
 * "6.0" (or "6.10", or any other trailing-zero decimal) got wrongly
 * rejected. Matching the string shape directly, instead of round-
 * tripping through a lossy numeric conversion, avoids that - "6.0" and
 * "6.10" are both valid, "5.0 Hello world" still is not.
 * @param {*} value
 * @return {boolean}
 */
function isValidDimensionString(value) {
    return /^-?\d+(\.\d+)?$/.test(String(value ?? '').trim())
}

function snapshotQuoteFields(quote) {
    return JSON.parse(JSON.stringify({
        given_id: quote.given_id,
        customer_name: quote.customer_name,
        asante_contact_info: quote.asante_contact_info,
        contact_info: quote.contact_info,
        quote_date: quote.quote_date,
        adjustments: quote.adjustments,
        shipping_cost: quote.shipping_cost,
        comments: quote.comments,
        total_price: quote.total_price,
    }))
}

const rowStyle = {
//    'marginLeft': '0px',
//    'marginRight': '0px',
}

class QuoteViewController extends React.Component {

    // MARK: Override Functions

    constructor(props) {
        super(props)
        const account = Account.fromCookieAndLocalStorage()
        if (props.quote) {
            const quote = props.quote
            if (account.isCustomer()) {
                quote.customer_name = account.company
                quote.autogenQuoteNumber()
            }
            this.state = {
                original_job_name: props.quote.job_name,
                original_signs: [],
                original_quote_fields: {},
                quote: quote,
                all_types: [], // Type object
                all_addons: {}, // UUID to addon object
                customerNames: [],
                firstNamesQuotes: [],
                asanteContactInfos: [],
                didModifyContactShippingInfo: false,
                account: account,
                addonsIndexShow: "-1--1",
                quote_number_changed: false,
                minimized_subsigns: [],
                new_signs_json: '',
                suggest_file: null,
            }
        } else {
            this.state = {
                original_job_name: '',
                original_signs: [],
                original_quote_fields: {},
                quote: null,
                all_types: [], // Type object
                all_addons: {}, // UUID to addon object
                customerNames: [],
                firstNamesQuotes: [],
                asanteContactInfos: [],
                didModifyContactShippingInfo: false,
                account: account,
                addonsIndexShow: "-1--1",
                quote_number_changed: false,
                minimized_subsigns: [],
                new_signs_json: '',
                suggest_file: null,
            }
        }
    }

    componentDidMount() {
        if (this.props.id) {

            this.props.turnOnLoader()
            getQuote(this.props.id)
                .then(
                    (result) => {

                        const quote = Quote.from(result.data.quote)

                        // Update addons
                        let ids = []
                        for (let i = 0; i < result.data.quote.signs.length; i++) {
                            ids.push(result.data.quote.signs[i].type.id)
                            for (let j = 0; j < result.data.quote.signs[i].subsigns.length; j++) {
                                ids.push(result.data.quote.signs[i].subsigns[j].type.id)
                            }
                        }
                        while (ids.length > 0) {
                            const first = ids[0]
                            this.updateAddonsRequest(first, quote)
                            ids = ids.filter((item) => item !== first)
                        }

                        if (result.data.quote.signs.length === 0) {
                            result.data.quote.signs = [new Sign()]
                        }

                        this.setState({
                            original_job_name: quote.job_name,
                            original_signs: JSON.parse(JSON.stringify(quote.signs)),
                            original_quote_fields: snapshotQuoteFields(quote),
                            quote: quote,
                            didModifyContactShippingInfo: quote.hasInformationFilledIn(),
                            quote_number_changed: true,
                        })

                        this.props.turnOffLoader()
                    },
                    (error) => {
                        this.props.showError(error)
                        this.props.turnOffLoader()
                    }
                )
        }

        this.props.turnOnLoader()
        getTypes().then(
            (result) => {
                result.data.types.sort(function(lhs, rhs) {
                    if (lhs.order_index !== rhs.order_index) {
                        return lhs.order_index - rhs.order_index
                    }

                    const ordering = {
                        'Raster Braille': 0,
                        'Acrylic Applied': 1,
                        'Thermoformed': 2,
                        'Laminate': 3,
                        'Digital Print': 4,
                        'Evac Maps & Window Only': 5,
                        'Glass Backers': 6,
                        'Non Tactile Window Sign': 7,
                        'Unfinished': 8,
                        'Other': 10,
                    }

                    function getValue(s) {
                        let m = s.match(/[ ]*Date/)
                        if (m) {
                            let root = s.substr(0, m.index)
                            return ordering[root] + 100
                        }
                        return ordering[s]
                    }

                    const lOrder = getValue(lhs.label)
                    const rOrder = getValue(rhs.label)
                    return lOrder - rOrder
                })
                this.setState({
                    all_types: result.data.types,
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    // this toggles custom addons
    hideCustomAddons(newIndex="-1--1", scrollUp=false) {
        if (newIndex === this.state.addonsIndexShow) {
            newIndex = "-1--1"
        }

        const isMinimizing = this.state.addonsIndexShow !== "-1--1" &&
            newIndex === "-1--1"
        if (scrollUp && isMinimizing) {
            if (scrollUp &&
                document.querySelector('#currentaddonbox')) {
                window.scrollBy(0, -document.querySelector('#currentaddonbox').clientHeight)
            }
        }

        this.setState({
            'addonsIndexShow': newIndex,
        })
    }

    // MARK: Const functions

    didUpdateJobName() {
        return this.props.id && this.state.quote.job_name !== this.state.original_job_name
    }

    formatAddonPrice(price) {
        const rounded = Math.round(price*1000) / 1000
        return rounded
    }

    // MARK: Update Values

    updateAddonsRequest(typeId, quote=null, onUpdated=(newAddons)=>{}) {

        if (!quote) {
            quote = this.state.quote
        }

        // Lets reset the quote addons to []
        this.setState(function(state, props) {

            // Make sure we didnt already update them
            if (typeId in state.all_addons) {
                return {}
            }

            const new_all_addons = state.all_addons
            new_all_addons[typeId] = []
            return {
                'all_addons': new_all_addons,
            }
        })

        // We already have the data. No need to get it again
        if (typeId in this.state.all_addons && this.state.all_addons[typeId].length > 0) {
            onUpdated(this.state.all_addons[typeId])
            return
        }

        if (typeId === null) {
            onUpdated(this.state.all_addons[typeId])
            return
        }

        // Lets get the addon
        this.props.turnOnLoader()
        getAddons(typeId)
        .then(
            (result) => {

                result.data.addons = result.data.addons.map((addon) =>
                    AddonWithOptions.from(addon))

                // We dont use inuse anymore
                result.data.addons = result.data.addons.filter((addon) => {
                    return addon.inuse || quote.hasAddonWithOptions(addon)
                })

                result.data.addons = result.data.addons.sort(function(lhs, rhs) {

                    // if (lhs.unit_price !== rhs.unit_price) {
                    //     return lhs.unit_price - rhs.unit_price
                    // }
                    // if (lhs.square_inch_price !== rhs.square_inch_price) {
                    //     return lhs.square_inch_price - rhs.square_inch_price
                    // }
                    // if (lhs.count !== rhs.count) {
                    //     return rhs.count - lhs.count
                    // }
                    // return lhs.label.localeCompare(rhs.label)

                    if (lhs.type_id !== rhs.type_id) {
                        if (lhs.type_id === null) {
                            return 1
                        }
                        if (rhs.type_id === null) {
                            return -1
                        }
                        return lhs.type_id.localeCompare(rhs.type_id)
                    }

                    if (lhs.cost_order_index !== rhs.cost_order_index) {
                        return lhs.cost_order_index - rhs.cost_order_index
                    }
                    if (lhs.order_index !== rhs.order_index) {
                        return lhs.order_index - rhs.order_index
                    }

                    if (lhs.options.length === 0 || rhs.options.length === 0) {
                        return lhs.options.length - rhs.options.length
                    }

                    if (lhs.options[0].length === 0 || rhs.options[0].length === 0) {
                        return lhs.options[0].length - rhs.options[0].length
                    }

                    let loption = lhs.options[0][0]
                    let roption = rhs.options[0][0]

                    if (loption.unit_price !== roption.unit_price) {
                        return loption.unit_price - roption.unit_price
                    }

                    if (loption.square_inch_price !== roption.square_inch_price) {
                        return loption.square_inch_price - roption.square_inch_price
                    }

                    if (loption.label !== roption.label) {
                        if (loption.label < roption.label) {
                            return -1
                        }
                        if (loption.label > roption.label) {
                            return 1
                        }
                    }

                    return 0
                })

                this.setState(function(state, props) {
                    const new_all_addons = state.all_addons

                    new_all_addons[typeId] = []
                    for (let i = 0; i < result.data.addons.length; i++) {
                        new_all_addons[typeId].push(result.data.addons[i])
                    }

                    onUpdated(new_all_addons[typeId])
                    return {
                        all_addons: new_all_addons
                    }
                })
                this.props.turnOffLoader()
            },
            (error) => {
                onUpdated([])
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }


    // MARK: Suggest Quote

    // Entirely client-orchestrated, composed from the same two plain
    // requests any other "create a quote" / "upload a file" action in
    // this app already uses - createQuote() (the same call the normal
    // "New Quote" save flow makes) and uploadFile() (the same call the
    // Files page's own uploader makes, see UploadFileViewController.js).
    // There's no special-cased server route combining the two - the
    // server-side extraction that follows the upload is the ordinary
    // per-file extraction every upload already triggers, nothing more.
    onSubmitSuggestQuote() {
        if (!this.state.suggest_file) {
            return
        }

        this.props.turnOnLoader()
        createQuote(this.state.quote).then(
            (result) => {
                const quoteId = result.data.quote.id
                uploadFile(quoteId, this.state.suggest_file).then(
                    () => {
                        this.props.turnOffLoader()
                        this.props.showAlertModal(
                            (new AlertModalModel())
                                .setTitle('Processing Your File')
                                .setMessage('This can take a few ' +
                                    'minutes. The quote itself will ' +
                                    'stay blank until you ask for it - ' +
                                    'upload every file we\'d typically ' +
                                    'need for this job first (drawings, ' +
                                    'CDR files, spec sheets, purchase ' +
                                    'orders, any customer emails/' +
                                    'messages - the more we have, the ' +
                                    'better the suggestion will be), ' +
                                    'then come back to this quote and ' +
                                    'click "Suggest from Files" when ' +
                                    'you\'re ready.')
                                .addBottomRightBotton('Upload More Files', () => {
                                    this.props.closeModal()
                                    window.location.href =
                                        frontEndBaseURL + '/files/' + quoteId
                                })
                                .addCancelButton(() => {
                                    this.props.closeModal()
                                    window.location.href =
                                        frontEndBaseURL + '/quote/' + quoteId
                                })
                        )
                    },
                    (error) => {
                        this.props.showError(error)
                        this.props.turnOffLoader()
                    }
                )
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    isBlankQuote() {
        // See Quote.isBlank() (shared_src/model/Quote.js) - shared with
        // the server-side gate on the "Suggest from Files" route so the
        // rule can't drift between the two.
        return !!this.state.quote?.isBlank()
    }

    // Applies a suggestion into local form state ONLY - never saved to the
    // server by this. buildSuggestionFromMergedMetadata() (server side)
    // never writes to the database either; the point of this button is a
    // draft the user reviews/edits like anything else on this page and
    // saves themselves via the quote's normal save flow, not an
    // auto-fill. Merges rather than replaces - only the keys the
    // suggestion actually has a value for (job_name, comments,
    // customer_name, contact/shipping info, signs) overwrite the current
    // in-memory quote; anything it left out stays as-is.
    onSubmitSuggestQuoteFromFiles() {
        this.props.turnOnLoader()
        suggestQuoteFromFiles(this.props.id).then(
            (result) => {
                const suggestion = result.data.suggestion
                // Quote.from() already runs every sign through Sign.from()
                // (and every contact/shipping field through its own
                // .from()) unconditionally - no need to pre-convert here.
                // The server only ever sets suggestion.signs when it has
                // real signs to propose (never an empty array), so a
                // plain spread already does the right thing on its own:
                // suggestion's signs win when present, the quote's
                // current signs survive untouched when they're not.
                const quote = Quote.from({...this.state.quote, ...suggestion})

                // Same per-sign-type addon list resolution
                // componentDidMount() does on first load - without this a
                // newly-proposed sign type's addon checkboxes wouldn't
                // have anything to render.
                const typeIds = new Set()
                for (const sign of quote.signs) {
                    if (sign.type?.id) {
                        typeIds.add(sign.type.id)
                    }
                    for (const subsign of sign.subsigns ?? []) {
                        if (subsign.type?.id) {
                            typeIds.add(subsign.type.id)
                        }
                    }
                }
                for (const typeId of typeIds) {
                    this.updateAddonsRequest(typeId, quote)
                }

                this.setState({quote})
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    renderSuggestQuote() {
        if (!this.props.id) {
            return <Row style={rowStyle}>
                <Col>
                    <Input
                        type="file"
                        style={{'display': 'inline-block', 'width': 'auto'}}
                        onChange={(e) => {
                            this.setState({
                                suggest_file: e.target.files[0] || null,
                            })
                        }} />
                    <Button
                        style={{'marginLeft': '10px'}}
                        disabled={!this.state.suggest_file}
                        onClick={() => this.onSubmitSuggestQuote()}
                    >Suggest Quote From File</Button>
                    <InfoButton
                        id={'suggest-quote-from-file'}
                        style={{'marginLeft': '10px'}}
                        message={'A starting point, not a finished quote. ' +
                            'Auto-quoting reads what it can from the file and ' +
                            'will miss or misread details, so check every ' +
                            'sign, size and price before sending it out.'} />
                </Col>
            </Row>
        }

        if (!this.isBlankQuote()) {
            return <></>
        }

        return <Row style={rowStyle}>
            <Col>
                <Button
                    onClick={() => this.onSubmitSuggestQuoteFromFiles()}
                >Suggest from Files</Button>
            </Col>
        </Row>
    }

    // MARK: Update Drop Down Text Fields

    fillInBlankFields(newQuote) {
        this.setState(function(state, props) {
            const stateQuote = state.quote
            if (this.state.didModifyContactShippingInfo === false) {
                stateQuote.fillInformationFromQuote(newQuote, true)
            } else {
                this.props.showAlertModal((new AlertModalModel())
                    .setTitle('Question?')
                    .setMessage('Would you like to modify already typed in contact and shipping sub fields?')
                    .addBottomRightBotton('Yes', () => {
                        stateQuote.fillInformationFromQuote(newQuote, true)
                        this.props.closeModal()
                    })
                    .addBottomRightBotton('No', () => {
                        stateQuote.fillInformationFromQuote(newQuote, false)
                        this.props.closeModal()
                    })
                )
            }
            return {
                'quote': stateQuote,
            }
        })
    }

    fillInBlankFieldsWithCustomerName(customerName) {
        this.props.turnOnLoader()
        getContactInfo('contact_info', customerName, '').then(
            (result) => {
                if (result.data.info.length === 0) { return }
                const quote = Quote.from(result.data.info[0])
                this.fillInBlankFields(quote)
                this.updateFirstNameDropDown(customerName, quote.contact_info.first_name)
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    updateCustomerNameDropDown(customerName) {
        if (customerName.length > 1) {
            getCustomerNames(customerName)
            .then(
                (result) => {
                    this.setState({
                        'customerNames': result.data.customer_names
                    })
                },
                (error) => {
                    this.props.showError(error)
                }
            )
        } else {
            this.setState({
                'customerNames': [],
            })
        }
    }

    updateFirstNameDropDown(customerName, firstName) {
        if (firstName.length > 1) {
            getContactInfo('contact_info', customerName, firstName)
            .then(
                (result) => {
                    const quotes = []
                    for (let i = 0; i < result.data.info.length; i++) {
                        quotes.push(Quote.from(result.data.info[i]))
                    }
                    this.setState({
                        'firstNamesQuotes': quotes
                    })
                },
                (error) => {
                    this.props.showError(error)
                }
            )
        } else {
            this.setState({
                'firstNamesQuotes': [],
            })
        }
    }


    updateSignField(index, sign, fieldName, value) {
        const quote = this.state.quote
        if (sign[fieldName] === value) {
            return
        }

        if (fieldName === 'type') {
            this.updateAddonsRequest(value.id, null, (newAddons) => {
                // We decided to remove all adons except custom addons
                // I am keeping this code here justin case
                // const idSet = {}
                // for (let i = 0; i < newAddons.length; i++) {
                //     idSet[newAddons[i].id] = true
                // }

                // quote.signs[index].addons =
                //     quote.signs[index].addons.filter((sign) => sign.id in idSet)
            })

            value = SignType.from(value)
            if (value.id === sign.type.id || value.labelNoDate() === sign.type.labelNoDate()) {
                // this.props.turnOnLoader()
                // convertAddons(value.id, quote.signs[index].addons.map((x)=> x.label))
                // .then(
                //     (result) => {
                //         result.data.new_addons = result.data.new_addons.map((addon) => 
                //             SignAddon.from(addon)
                //         )
                //         quote.signs[index].addons = result.data.new_addons
                //         this.setState({
                //             'quote': quote,
                //         })
                //         this.props.turnOffLoader()
                //     },
                //     (error) => {
                //         this.props.showError(error)
                //         this.props.turnOffLoader()
                //     }
                // )
            } else {
                sign.resetAddons()
            }
        }

        sign.setField(fieldName, value)

        this.setState(function(state, props) {
            return {
                quote: quote
            }
        })
    }

    updateComments(value) {
        const quote = this.state.quote
        quote.comments = value
        this.setState({'quote': quote})
    }

    updateSubQuoteField(fieldName1, fieldName2, value) {

        if ((fieldName1 === 'contact_info' && fieldName2 !== 'first_name') ||
            fieldName1 === 'shipping_info') {

            this.setState({
                'didModifyContactShippingInfo': true
            })
        }

        const quote = this.state.quote
        quote[fieldName1][fieldName2] = value

        this.setState(function(state, props) {
            return {
                'quote': quote
            }
        })
    }

    updateAdds(signIndex, childIndex, addon) {
        const quote = this.state.quote
        if (childIndex === -1) {
            quote.signs[signIndex].toggleAddon(addon)
        } else {
            quote.signs[signIndex].subsigns[childIndex].toggleAddon(addon)
        }
        this.setState(function(state, props) {
            return {
                quote: quote
            }
        })
    }

    onKeyDownOnSignTextField(e, index, childIndex) {

        if (!this.state.account.settings.excel_arrow_keys) {
            return
        }

        let down = 0
        let right = 0
        switch (e.keyCode) {
            case 37:
                right = -1
                break
            case 38:
                down = -1
                break
            case 39:
                right = 1
                break
            case 40:
                down = 1
                break
            case 13:
                down = 1
                break
            default:
                break
        }

        if (e.shiftKey) {
            down *= -1
            right *= -1
        }

        if (down === 0 && right === 0) {
            return
        }

        const varNames = ['given_id', 'width', 'height', 'quantity']

        let varName =
            e.target.id.substring(0, e.target.id.indexOf('-'))

        function mod(n, m) {
            return ((n % m) + m) % m;
        }

        varName = varNames[mod((varNames.indexOf(varName) + right), varNames.length)]
        const nextVarName = varNames[mod((varNames.indexOf(varName) + 1), varNames.length)]
        const prevVarName = varNames[mod((varNames.indexOf(varName) - 1), varNames.length)]

        let element = document.getElementById(varName + '-' +
            (index+ (childIndex === -1 ? down : 0)) + '-' +
            (childIndex === -1 ? '-1' : childIndex + down))

        if (!element) {
            if (down === -1) {
                element = document.getElementById(prevVarName + '-' +
                    ((childIndex === -1 ?
                        this.state.quote.signs.length :
                        this.state.quote.signs[index].subsigns.length
                    )-1)
                )
            } else if (down === 1) {
                element = document.getElementById(nextVarName + '-' +
                    (childIndex === -1 ? '0' : '' + index) + '-' +
                    (childIndex === -1 ? '-1' : '0'))
            }
        }

        if (element) {
            element.focus()
            element.select()
        }
    }

    deleteSign(index, childIndex=-1) {
        const name = childIndex === -1 ?
            this.state.quote.signs[index].given_id :
            this.state.quote.signs[index].subsigns[childIndex].given_id
        this.props.showAlertModal(
            (new AlertModalModel())
                .setTitle('Warning')
                .setMessage('Are you sure you want to delete ' + name + '. ' +
                    'This action can not be undone.')
                .addYesButton((e) => {
                    // Not the this.setState(function(state) {...}) form -
                    // React (in dev/StrictMode) invokes that updater form
                    // twice to catch impure updaters, and this one mutates
                    // quote.signs via splice() rather than returning a new
                    // object, so the second (normally-discarded) call was
                    // still splicing for real against the already-mutated
                    // array, removing whatever sign had shifted into the
                    // just-deleted spot.
                    const quote = this.state.quote
                    if (childIndex === -1) {
                        quote.signs.splice(index, 1)
                    } else {
                        quote.signs[index].subsigns.splice(childIndex, 1)
                    }
                    this.setState({
                        quote: quote,
                    })
                    this.props.closeModal()
                })
                .addCancelButton((e) => {this.props.closeModal()})
        )
    }

    getGivenIdOfNewSign(index, childIndex=-1) {
        const newSign = childIndex === -1 ?
            this.state.quote.signs[index] :
            this.state.quote.signs[index].subsigns[childIndex]

        if (this.state.account.settings.auto_type_sign_type) {
            const beforeName = newSign.given_id
            let afterName = null
            if (childIndex === -1 && index+1 < this.state.quote.signs.length) {
                afterName = this.state.quote.signs[index+1].given_id
            }
            else if (childIndex !== -1 && childIndex+1 < this.state.quote.signs[index].subsigns.length) {
                afterName = this.state.quote.signs[index].subsigns[childIndex+1].given_id
            }
            else if (childIndex !== -1 && index+1 < this.state.quote.signs.length) {
                afterName = this.state.quote.signs[index+1].given_id
            }

            const newName = giveName(beforeName, afterName)
            if (newName) {
                return newName
            } else {
                return ''
            }
        } 

        return ''
    }

    copySign(index, childIndex=-1) {
        const quote = this.state.quote
        const newSign = childIndex === -1 ?
            quote.signs[index].copy() :
            quote.signs[index].subsigns[childIndex].copy()

        newSign.given_id = this.getGivenIdOfNewSign(index, childIndex)

        let newSigns = childIndex === -1 ?
            quote.signs.slice(0, index+1) :
            quote.signs[index].subsigns.slice(0, childIndex+1)
        newSigns.push(newSign)
        if (childIndex === -1) {
            newSigns = newSigns.concat(quote.signs.slice(index+1))
            quote.signs = newSigns
        } else {
            newSigns = newSigns.concat(quote.signs[index].subsigns.slice(childIndex+1))
            quote.signs[index].subsigns = newSigns
        }

        this.setState({
            'quote': quote,
        })
    }


    appendSign() {
        const quote = this.state.quote
        if (quote.signs.length > 0) {
            const sign = quote.signs[quote.signs.length - 1].copyRemoveAddons()
            sign.given_id = this.getGivenIdOfNewSign(this.state.quote.signs.length-1)
            quote.signs.push(sign)
        } else {
            quote.signs.push(new Sign())
        }

        this.setState(function(state, props) {
            return {
                quote: quote
            }
        })
    }

    copyContactInfoToShippingAddr() {
        const quote = this.state.quote
        quote.copyContactInfoToShippingInfo()
        this.setState({
            'quote': quote,
        })
    }

    saveQuote() {

        // Validation

        for (let i = 0; i < this.state.quote.signs.length; i++) {
            let notValidFields = ''
            if (isNaN(parseInt(this.state.quote.signs[i].quantity)) ||
                parseInt(this.state.quote.signs[i].quantity).toString() !==
                    this.state.quote.signs[i].quantity.toString()
            ) {
                if (notValidFields.length > 0) {
                    notValidFields += ', '
                }
                notValidFields += 'quantity'
            }
            if (!isValidDimensionString(this.state.quote.signs[i].width)) {
                if (notValidFields.length > 0) {
                    notValidFields += ', '
                }
                notValidFields += 'width'
            }
            if (!isValidDimensionString(this.state.quote.signs[i].height)) {
                if (notValidFields.length > 0) {
                    notValidFields += ', '
                }
                notValidFields += 'height'
            }

            let subsignMsg = []
            for (let j = 0;
                j < this.state.quote.signs[i].subsigns.length; j++) {
                if (
                    isNaN(parseInt(this.state.quote.signs[i].subsigns[j].quantity)) ||
                    parseInt(this.state.quote.signs[i].subsigns[j].quantity).toString() !==
                        this.state.quote.signs[i].subsigns[j].quantity.toString()
                ) {
                    subsignMsg.push('' + (j+1) + 'th subsign quantity');
                }

                if (!isValidDimensionString(
                    this.state.quote.signs[i].subsigns[j].width)) {
                    subsignMsg.push('' + (j+1) + 'th subsign width');
                }

                if (!isValidDimensionString(
                    this.state.quote.signs[i].subsigns[j].height)) {
                    subsignMsg.push('' + (j+1) + 'th subsign height');
                }
            }
            if (subsignMsg.length > 0) {
                if (notValidFields.length > 0) {
                    notValidFields += ', '
                }
                notValidFields += subsignMsg.join(', ')
            }

            for (let j = 0;
                j < this.state.quote.signs[i].custom_addons.custom_addons.length; j++) {

                if (isNaN(parseFloat(
                    this.state.quote.signs[i].custom_addons.custom_addons[j].square_inch_price_no_size
                ))) {
                    if (notValidFields.length > 0) {
                        notValidFields += ', '
                    }
                    notValidFields += `${j+1}th custom addon square inch price no size`
                }

                if (isNaN(parseFloat(
                    this.state.quote.signs[i].custom_addons.custom_addons[j].square_inch_price
                ))) {
                    if (notValidFields.length > 0) {
                        notValidFields += ', '
                    }
                    notValidFields += `${j+1}th custom addon square inch price`
                }

                if (isNaN(parseFloat(
                    this.state.quote.signs[i].custom_addons.custom_addons[j].unit_price
                ))) {
                    if (notValidFields.length > 0) {
                        notValidFields += ', '
                    }
                    notValidFields += `${j+1}th custom addon unit price`
                }
            }

            if (notValidFields.length > 0) {
                this.props.showAlertModal(
                    (new AlertModalModel())
                        .setTitle('Error')
                        .setMessage('The following fields in the signs table ' +
                            '(row ' + (i+1) + ', ' + this.state.quote.signs[i].given_id +
                            ') must be a number: ' + notValidFields)
                        .addOkButton(() => {
                            this.props.closeModal()
                        })
                )
                return
            }

            if (this.state.quote.signs[i].type.id === null) {
                this.props.showAlertModal(
                    (new AlertModalModel())
                        .setTitle('Error')
                        .setMessage('Every sign needs a process. Would you like to change every empty process to Other? You must hit save again.')
                        .addYesButton(() => {
                            this.setState(function(state, props) {
                                const quote = state.quote
                                const other = state.all_types.find((x) => x.label === 'Other')
                                for (let j = 0; j < quote.signs.length; j++) {
                                    if (quote.signs[j].type.id === null) {
                                        if (other) {
                                            quote.signs[j].type = other
                                        }
                                    }
                                }

                                return {
                                    'quote': quote
                                }
                            })

                            this.props.closeModal()
                        })
                        .addNoButton(() => {
                            this.props.closeModal()
                        })
                )

                return
            }
        }

        let errorMSG = ''
        if (this.state.quote.job_name === '') {
            errorMSG += 'Quote needs a value in job name.'
        }

        if (Number.isNaN(Number.parseFloat(this.state.quote.shipping_cost))) {
            errorMSG += 'Quote needs a numeric value in shipping cost.'
        }

        for (let i = 0; i < this.state.quote.adjustments.length; i++) {
            if (
                Number.isNaN(Number.parseFloat(this.state.quote.adjustments[i].percent))
            ) {
                errorMSG += `Quote needs a numeric value in ${i+1}th adjustments for percent value.`
            }
            if (
                Number.isNaN(Number.parseFloat(this.state.quote.adjustments[i].dollar))
            ) {
                errorMSG += `Quote needs a numeric value in ${i+1}th adjustments for dollar value.`
            }
        }

        if (errorMSG !== '') {
            this.props.showAlertModal(
                (new AlertModalModel())
                    .setTitle('Error')
                    .setMessage(errorMSG)
                    .addCancelButton(() => {
                        this.props.closeModal()
                    })
            )
            return
        }

        // Validation Successful

        function signSaveFailureMessage(failure, index) {
            return <div key={index}>
                {failure.given_id + ' (' + failure.action + '): '}
                {errorMessage(failure.error)}
            </div>
        }

        function showSignSaveFailures(ctx, failures) {
            const message = <>
                <div>The following signs failed to save:</div>
                {failures.map(signSaveFailureMessage)}
            </>

            ctx.props.showAlertModal(
                (new AlertModalModel())
                    .setTitle('Error')
                    .setMessage(message)
                    .addOkButton(() => {
                        ctx.props.closeModal()
                    })
            )
        }

        function quoteFieldChanged(ctx, key, newValue) {
            const oldValue = ctx.state.original_quote_fields[key]
            if (['asante_contact_info', 'contact_info', 'adjustments', 'quote_date'].indexOf(key) !== -1) {
                return JSON.stringify(oldValue) !== JSON.stringify(newValue)
            }
            if (['shipping_cost', 'total_price'].indexOf(key) !== -1) {
                const oldNum = parseFloat(oldValue)
                const newNum = parseFloat(newValue)
                if (isNaN(oldNum) || isNaN(newNum)) {
                    // e.g. a legacy quote with a null shipping_cost getting
                    // a real value for the first time - fall back to a
                    // plain compare instead of NaN >= 0.001, which is
                    // always false and would silently drop the change
                    return oldValue !== newValue
                }
                return Math.abs(oldNum - newNum) >= 0.001
            }
            return oldValue !== newValue
        }

        function nextOriginalSigns(prevSigns, signs, failures) {
            const failedIds = new Set(failures.map((f) => f.id).filter(Boolean))

            // Signs that saved successfully move forward to their new
            // value; ones that failed (even after the individual retry)
            // keep their previous baseline value, so the next save's diff
            // still sees them as changed and retries instead of silently
            // treating a failed change as already persisted. A still-id-
            // less sign (insert failed, or never attempted) is naturally
            // "new" again next time, so it's just left out here.
            const next = signs
                .filter((sign) => sign.id)
                .map((sign) => {
                    if (failedIds.has(sign.id)) {
                        return prevSigns.find((p) => p.id === sign.id)
                    }
                    return JSON.parse(JSON.stringify(sign))
                })
                .filter(Boolean)

            // A sign whose delete failed no longer exists in `signs` (the
            // user already removed it in the editor) but still exists on
            // the server - keep it in the baseline so the next save
            // retries the delete instead of forgetting about it.
            for (let i = 0; i < prevSigns.length; i++) {
                const stillPresent = signs.find((s) => s.id === prevSigns[i].id)
                if (!stillPresent && failedIds.has(prevSigns[i].id)) {
                    next.push(prevSigns[i])
                }
            }

            return next
        }

        function saveSignsThenFinish(ctx) {
            for (let i = 0; i < ctx.state.quote.signs.length; i++) {
                ctx.state.quote.signs[i].order_index = i
            }

            const prevSigns = ctx.state.original_signs
            updateSigns(
                prevSigns,
                ctx.state.quote.signs,
                ctx.state.quote.id
            ).then((failures) => {
                if (failures.length > 0) {
                    showSignSaveFailures(ctx, failures)
                }

                ctx.setState({
                    'original_signs': nextOriginalSigns(prevSigns, ctx.state.quote.signs, failures),
                }, () => {
                    ctx.props.turnOffLoader()
                })
            })
        }

        function localUpdateQuote(ctx) {
            ctx.props.turnOnLoader()
            const quote = Object.assign({}, ctx.state.quote)
            if (!ctx.didUpdateJobName()) {
                quote.job_name = undefined
            }

            const smaller_quote = ((
                {
                    id,
                    given_id,
                    job_name,
                    customer_name,
                    asante_contact_info,
                    contact_info,
                    quote_date,
                    adjustments,
                    shipping_cost,
                    comments,
                    total_price,
                }
            ) => (
                {
                    id,
                    given_id,
                    job_name,
                    customer_name,
                    asante_contact_info,
                    contact_info,
                    quote_date,
                    adjustments,
                    shipping_cost,
                    comments,
                    total_price,
                }
            ))(quote)

            // Only send fields that actually changed since load - same
            // targeted-write principle as updateSigns(), avoids a no-op
            // PUT/wide-write race when nothing (or only signs) changed.
            for (let key in smaller_quote) {
                if (key === 'id' || key === 'job_name') {
                    continue
                }
                if (!quoteFieldChanged(ctx, key, smaller_quote[key])) {
                    smaller_quote[key] = undefined
                }
            }

            const hasQuoteChanges = Object.keys(smaller_quote).some((key) =>
                key !== 'id' && smaller_quote[key] !== undefined)

            if (hasQuoteChanges) {
                updateQuote(smaller_quote).then(
                    (result) => {
                        ctx.setState({
                            original_quote_fields: snapshotQuoteFields(ctx.state.quote),
                        })
                        saveSignsThenFinish(ctx)
                    },
                    (error) => {
                        ctx.props.showError(error)
                        ctx.props.turnOffLoader()
                    }
                )
            } else {
                saveSignsThenFinish(ctx)
            }
        }

        function localCreateQuote(ctx) {
            ctx.props.turnOnLoader()
            createQuote(ctx.state.quote).then(
                (result) => {
                    window.location.href = frontEndBaseURL + '/quote/' + result.data.quote.id
                    ctx.props.turnOffLoader()
                },
                (error) => {
                    ctx.props.showError(error)
                    ctx.props.turnOffLoader()
                }
            )
        }

        let message = ''
        if (this.didUpdateJobName()) {
            message += 'The job name has been updated. '
        }

        if (this.state.quote.is_shipped) {
            message += 'The job has already been shipped. '
        }

        if (message.length > 0) {
            this.props.showAlertModal(
                (new AlertModalModel())
                    .setTitle('Do you want to save as a new job?')
                    .setMessage('The reasons for asking you are listed. ' + message +
                        'Note that you wont copy backlogs, scheduler and files. ' +
                        'Only the quote. The new job will be not shipped as well. '
                    )
                    .addBottomRightBotton('New Job', () => {
                        localCreateQuote(this)
                        this.props.closeModal()
                    })
                    .addBottomRightBotton('Update Current Job As Revision', () => {
                        localUpdateQuote(this)
                        this.props.closeModal()
                    })
                    .addCancelButton(() => {
                        this.props.closeModal()
                    })
            )
        } else {
            this.state.quote.sortAddons(this.state.all_addons)
            // Check if its an old quote
            if (this.state.quote.id && this.state.quote.id.length > 0) {
                localUpdateQuote(this)
            } else {
                localCreateQuote(this)
            }
        }
    }


    // MARK: PDF

    downloadAndViewPDF() {
        const quote = this.state.quote
        if (downloadPDF(quote, false)) {
            this.props.showAlertModal(
                (new AlertModalModel())
                    .setTitle('Warning')
                    .setMessage('To download the pdf you must have saved it first. ' +
                        'We will use the information of the last time you saved this quote to generate a pdf. ' +
                        'Do you wish to continue?')
                    .addYesButton((e) => {
                        downloadPDF(quote, true)
                        this.props.closeModal()
                    })
                    .addCancelButton((e) => {this.props.closeModal()})
            )
        }
    }

    // MARK: Modal

    // MARK: Email Modal

    sendEmailAndCloseModal(emailModel) {
        const quote = this.state.quote
        this.props.turnOnLoader()
        sendEmail(quote, emailModel).then(
            (result) => {
                this.props.closeModal()
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )

    }

    popUpEmailModal() {
        this.props.showModal(
            <EmailModalController
                quote={this.state.quote}
                sendEmail={(modal) => this.sendEmailAndCloseModal(modal)} />
        )
    }

    popUpPackagingSlipModal() {
        this.props.showModal(
            <PackagingSlipModalController
                quote={this.state.quote}
                />
        )
    }

    // MARK: Process Modal

    addCustomAddon(index, model) {
        const quote = this.state.quote
        quote.signs[index].setField('custom_addons', model)

        this.setState({
            'quote': quote,
        })

        this.props.closeModal()
    }

    popUpCustomAddonsModal(index) {
        this.props.showModal(
            <CustomAddonsModalController
                model={this.state.quote.signs[index].custom_addons}
                addProccess={
                    (model) =>
                        this.addCustomAddon(index, model)}/>
        )
    }


    // MARK: View

    makeAddonsRow(sign, signIndex, childIndex) {
        const addons = this.state.all_addons[sign.type.id]

        if (!addons) { return <></> }

        if (!sign.picks) {
            sign.picks = {}
        }

        const headers = [
            ...new Set([
                ...addons.map((addon) => addon.cost_label),
                ...sign.addons.map((addon) => addon.cost_label),
            ]),
        ]

        return <>
            {headers.map((header) => {
            let headerAddons = addons.filter((x) => x.cost_label === header)
            const extraSelectedAddons = sign.addons.filter((addon) =>
                addon.cost_label === header &&
                    headerAddons.find((x) => x.getPicksOfAddon(addon, true) !== null) === undefined
            ).map((signAddon) => signAddon.toAddonWithOptions())
            headerAddons = headerAddons.concat(extraSelectedAddons.map((addon) => {
                addon.is_extra = true
                return addon
            }))
            return <div>
                <Label style={{
                    'fontWeight': '500',
                    'fontSize': '12pt'
                }}>{header}</Label>
                <div style={{
                    'marginLeft': '20px',
                }}>
                {headerAddons.map((addon, addonIndex) => {
                    let picks = sign.picks[addon.id]
                    if (!picks) {
                        picks = sign.getPicksOfAddon(addon)
                    }
                    if (!picks) {
                        picks = [...Array(addon.options.length)].map(() => 0)
                    }

                    const addonWithPicks = addon.toSignAddon(picks)

                    return <div style={{
                        'display': 'inline-block',
                        'marginLeft': '30px',
                    }}>
                        {
                            addon.options.map((options, optionIndex) =>
                            options.length === 1 ?
                                <Label style={{
                                    'fontFamily': 'sans-serif',
                                    'fontSize': '10pt',
                                }}>{options[picks[optionIndex]].label}</Label>
                            :
                            <SimpleDropdown
                                style={{
                                    'display': 'inline-block',
                                }}
                                size='sm'
                                index={picks[optionIndex]}
                                values={options.map((x) => x.label)}
                                onChange={(i) => {
                                    const signAddon = addon.toSignAddon(picks)
                                    sign.removeAddon(signAddon)
                                    picks[optionIndex] = i
                                    sign.picks[addon.id] = picks
                                    this.setState({})
                                }} />
                        )}
                        <Label style={{
                            'fontFamily': 'sans-serif',
                            'fontSize': '10pt',
                        }}>
                            { //formatAsDollarValue(
                                addonWithPicks.square_inch_price === 0 ?
                                (addonWithPicks.unit_price === 0 ? ''
                                    : '(' + this.formatAddonPrice(addonWithPicks.unit_price) + ')')
                                    : '(' + this.formatAddonPrice(addonWithPicks.square_inch_price) + ')'
                            }
                            {
                                addon.is_extra ? "Old Pricing": ""
                            }
                        </Label>
                        <Input
                            checked={sign.hasSignAddon(addon.toSignAddon(picks))}
                            onClick={(e) =>
                                this.updateAdds(signIndex, childIndex, addon.toSignAddon(picks))}
                            type="checkbox" />
                    </div>
                })}
                </div>
            </div>
        })}
            <Label style={{
                'fontWeight': '600',
                'fontSize': '14pt'
            }}>Process PDF Label</Label>
            <Input
                type='text'
                value={sign.getTypePDFLabel(childIndex!==-1)}
                onChange={(e) => {
                    sign.type.pdf_label = e.target.value
                    this.setState({
                        'quote': this.state.quote,
                    })
                }}
                />
            <Label style={{
                'fontWeight': '600',
                'fontSize': '14pt'
            }}>Custom Addons</Label>
            <Row style={rowStyle}><Col><div style={{'overflowX': 'auto'}}><Table>
                <thead>
                    <tr>
                        <th className="text-center label-weight"></th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '200px'}}>Description</th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '60px'}}>Raw Sqr Inch Price 
                            <InfoButton
                                id={'raw-sqr-inch-price'}
                                message={
                                    'Adds straight to the total square inch price for this sign.'
                                }
                                style={{
                                    'margin': '8px',
                                }}
                            />
                        </th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '60px'}}>Adjusted Sqr Inch Price
                            <InfoButton
                                id={'adjusted-sqr-inch-price'}
                                message={
                                    'Adjust the square inch price to be based on the ' +
                                    'minimum / maximum ' +
                                    'square inches price of the process. Usually based on 24 in or ' +
                                    '64 in.'
                                }
                                style={{
                                    'margin': '8px',
                                }}
                            />
                        </th>
                        <th className="text-center label-weight"
                            style={{'minWidth': '60px'}}>Unit Price Add</th>
                    </tr>
                </thead>
                <tbody>
                    {sign.custom_addons.custom_addons.map((addon, index) => {
                        return <tr>
                            <td>
                                <Button
                                    id={'move-custom-up-button-' + index}
                                    style={{
                                        'height': '10pt',
                                        'margin': '0pt',
                                        'padding': '0pt',
                                        'marginTop': '-10pt',
                                    }}
                                    size='sm'
                                    onClick={(e) => {
                                        if (index - 1 >= 0) {
                                            const rep = sign.custom_addons.custom_addons[index]
                                            sign.custom_addons.custom_addons[index] =
                                                sign.custom_addons.custom_addons[index-1]
                                            sign.custom_addons.custom_addons[index-1] =
                                                rep
                                            this.setState({
                                                'quote': this.state.quote,
                                            })
                                            document.getElementById(
                                                'move-custom-up-button-' + (index-1)
                                            ).focus()
                                        }
                                    }}>
                                    <IoIosArrowUp
                                        style={{
                                            'margin-top': '-10pt',
                                            'margin': '0pt',
                                            'padding': '0pt',
                                            'fontSize': '10pt',
                                            'fontWeight': 'bold',
                                            'marginTop': '-10pt',
                                        }}/>
                                </Button>
                                <Button
                                    id={'move-custom-down-button-' + index}
                                    style={{
                                        'height': '10pt',
                                        'margin': '0pt',
                                        'padding': '0pt',
                                        'marginTop': '-10pt',
                                    }}
                                    size='sm'
                                    onClick={(e) => {
                                        if (index + 1 < sign.custom_addons.custom_addons.length) {
                                            const rep = sign.custom_addons.custom_addons[index]
                                            sign.custom_addons.custom_addons[index] =
                                                sign.custom_addons.custom_addons[index+1]
                                            sign.custom_addons.custom_addons[index+1] =
                                                rep
                                            this.setState({
                                                'quote': this.state.quote,
                                            })
                                            document.getElementById(
                                                'move-custom-down-button-' + (index+1)
                                            ).focus()
                                        }
                                    }}>
                                    <IoIosArrowDown
                                        style={{
                                            'margin-top': '-10pt',
                                            'margin': '0pt',
                                            'padding': '0pt',
                                            'fontSize': '10pt',
                                            'fontWeight': 'bold',
                                            'marginTop': '-10pt',
                                        }}/>
                                </Button>
                            </td>
                            <td><Input
                                value={addon.label}
                                onChange={(e) => {
                                    addon.label = e.target.value
                                    this.setState({
                                        'quote': this.state.quote
                                    })
                                }}/></td>
                            <td><NumberTextField
                                showDigitsKeyPad={this.state.account.settings.numbers_calculator_show}
                                style={{
                                    'textAlign': 'right',
                                }}
                                value={addon.square_inch_price_no_size}
                                onChange={(e) => {
                                    addon.square_inch_price_no_size = e.target.value
                                    this.setState({
                                        'quote': this.state.quote
                                    })
                                }}/></td>
                            <td><NumberTextField
                                showDigitsKeyPad={this.state.account.settings.numbers_calculator_show}
                                style={{
                                    'textAlign': 'right',
                                }}
                                value={addon.square_inch_price}
                                onChange={(e) => {
                                    addon.square_inch_price = e.target.value
                                    this.setState({
                                        'quote': this.state.quote
                                    })
                                }}/></td>
                            <td><NumberTextField
                                showDigitsKeyPad={this.state.account.settings.numbers_calculator_show}
                                style={{
                                    'textAlign': 'right',
                                }}
                                value={addon.unit_price}
                                onChange={(e) => {
                                    addon.unit_price = e.target.value
                                    this.setState({
                                        'quote': this.state.quote
                                    })
                                }}/></td>
                            <td><Button color="danger" onClick={(e) => {
                                sign.custom_addons.removeAddon(index)
                                this.setState({
                                    'quote': this.state.quote
                                })
                            }}>Delete</Button></td>
                        </tr>
                    })}
                    <tr>
                        <td></td>
                        <td></td>
                        <td
                            style={{
                                'textAlign': 'right',
                            }}
                        ><Label style={{
                            'marginRight': '23px',
                        }}><span text={moneyText(sign.custom_addons.getSquareInchPriceNoSize())}>{
                            formatAsDollarValue(sign.custom_addons.getSquareInchPriceNoSize())
                        }</span></Label></td>
                        <td
                            style={{
                                'textAlign': 'right',
                            }}
                        ><Label style={{
                            'marginRight': '23px',
                        }}><span text={moneyText(sign.custom_addons.getTotalSquareInchPrice())}>{
                            formatAsDollarValue(sign.custom_addons.getTotalSquareInchPrice())
                        }</span></Label></td>
                        <td
                            style={{
                                'textAlign': 'right',
                            }}
                        ><Label style={{
                            'marginRight': '23px',
                        }}><span text={moneyText(sign.custom_addons.getTotalUnitPrice())}>{
                            formatAsDollarValue(sign.custom_addons.getTotalUnitPrice())
                        }</span></Label></td>
                    </tr>
                </tbody>
            </Table></div></Col></Row>
            <Row><Col style={{'textAlign': 'right'}}><Button color="success" style={{
                'marginRight': '24px',
            }} onClick={(e) => {
                sign.custom_addons.addAddon()
                this.setState({
                    'quote': this.state.quote
                })
            }}>Add Custom Addon</Button></Col></Row>
            <Row>
                <Col><Label style={{
                    'fontWeight': '500',
                    'fontSize': '12pt',
                }}>Percent Marked Up</Label></Col>
            </Row>
            <Row>
                <Col><NumberTextField
                        showDigitsKeyPad={this.state.account.settings.numbers_calculator_show}
                        style={{
                            'maxWidth': '200px'
                        }}
                        value={sign.custom_addons.percent_marked_up}
                        onChange={(e) => {
                            sign.custom_addons.percent_marked_up = e.target.value
                            this.setState({
                                'quote': this.state.quote
                            })
                        }}
                    /></Col>
            </Row>
            <Row>
                <Col><Label style={{
                    'fontWeight': '500',
                    'fontSize': '12pt',
                }}>Override Zero Quantity 
                    <InfoButton
                        id={'override-zero-quantity'}
                        message={
                            'If this is checked then this sign will appear in the pdf. ' +
                            'If its not checked then it will only appear in the pdf if ' +
                            'the quantity is not 0.'
                        }
                        style={{
                            'margin': '8px',
                        }}
                    />
            </Label></Col>
            </Row>
            <Row><Col>
                <Input
                    type="checkbox"
                    checked={sign.custom_addons.override_zero_quantity}
                    onClick={(e) => {
                        sign.custom_addons.override_zero_quantity =
                            !sign.custom_addons.override_zero_quantity
                        this.setState({
                            'quote': this.state.quote
                        })
                    }}
                />
            </Col></Row>
        </>
    }

    makeRow(sign, index, allowForFloatingTop=false, childIndex=-1, indexLevel=0) {
        const isTopBar = allowForFloatingTop && this.state.account.settings.sign_editing_top &&
               this.state.addonsIndexShow===index
        const all_types = this.state.all_types.filter((x) =>
            x.inuse || x.id === sign.type.id
        )
        if (all_types.findIndex((x) =>
            x.id === sign.type.id &&
                x.label === sign.type.label &&
                x.small_size_cost === sign.type.small_size_cost &&
                x.medium_size_cost === sign.type.medium_size_cost &&
                x.large_size_cost === sign.type.large_size_cost
        ) === -1) {
            if (sign.type.id === null) {
                all_types.push(sign.type)
            } else {
                const newType = JSON.parse(JSON.stringify(sign.type))
                newType.label += ' Outdated'
                all_types.push(newType)
            }
        }
        const tablerow = <><tr
           style={
                isTopBar ? {
                   'z-index': '20',
                   'color': 'red',
                   'backgroundColor': 'antiquewhite',
                   'position': 'fixed',
                   'top': '56px',
               } : {}
           }
           key={"row"+index+'-'+childIndex}>
                {false && this.state.quote.hasAddonThatCanBeUpgraded(this.state.all_addons) ?
                    <td>
                    {sign.hasAddonThatCanBeUpgraded(this.state.all_addons[sign.type.id]) ?
                        <Button
                            color="info"
                        onClick={(e) => {
                            sign.upgradeToNewestAddons(
                                this.state.all_addons[sign.type.id])
                            this.setState({
                                'quote':  this.state.quote
                            })
                        }}>Upgrade</Button>
                        : <></>
                    }
                    </td>:
                    <>
                    </>
                }
                <td>
                    <Button
                        id={'move-sign-up-button-' + index + '-' + childIndex}
                        style={{
                            'height': '10pt',
                            'margin': '0pt',
                            'padding': '0pt',
                            'marginTop': '-10pt',
                        }}
                        size='sm'
                        onClick={(e) => {
                            const quote = this.state.quote
                            if (childIndex === -1) {
                                if (index - 1 >= 0) {
                                    quote.signs[index].order_index -= 1
                                    quote.signs[index-1].order_index += 1
                                    const signAbove = quote.signs[index-1]
                                    quote.signs[index-1] = quote.signs[index]
                                    quote.signs[index] = signAbove
                                    this.setState({
                                        'quote': quote,
                                        'minimized_subsigns': [],
                                    })
                                    document.getElementById(
                                        'move-sign-up-button-' + (index-1) + '--1'
                                    ).focus()
                                }
                            } else if (childIndex > 0) {
                                quote.signs[index].subsigns = quote.signs[index].subsigns.swap(childIndex-1, childIndex)
                                this.setState({
                                    'quote': quote,
                                })
                                document.getElementById(
                                    'move-sign-up-button-' + (index) + '-' + (childIndex-1)
                                ).focus()
                            }
                        }}>
                        <IoIosArrowUp 
                            style={{
                                'margin-top': '-10pt',
                                'margin': '0pt',
                                'padding': '0pt',
                                'fontSize': '10pt',
                                'fontWeight': 'bold',
                                'marginTop': '-10pt',
                            }}/>
                    </Button>
                    <Button
                        id={'move-sign-down-button-' + index + '-' + childIndex}
                        style={{
                            'height': '10pt',
                            'margin': '0pt',
                            'padding': '0pt',
                            'marginTop': '-10pt',
                        }}
                        size='sm'
                        onClick={(e) => {
                            const quote = this.state.quote
                            if (childIndex === -1) {
                                if (index + 1 < quote.signs.length) {
                                    quote.signs[index].order_index += 1
                                    quote.signs[index+1].order_index -= 1
                                    const signAbove = quote.signs[index+1]
                                    quote.signs[index+1] = quote.signs[index]
                                    quote.signs[index] = signAbove
                                    this.setState({
                                        'quote': quote,
                                        'minimized_subsigns': [],
                                    })
                                    document.getElementById(
                                        'move-sign-down-button-' + (index+1) + '--1'
                                    ).focus()
                                }
                            } else if (childIndex + 1 < quote.signs[index].subsigns.length) {
                                quote.signs[index].subsigns = quote.signs[index].subsigns.swap(childIndex+1, childIndex)
                                this.setState({
                                    'quote': quote,
                                })
                                document.getElementById(
                                    'move-sign-down-button-' + (index) + '-' + (childIndex+1)
                                ).focus()
                            }
                        }}>
                        <IoIosArrowDown
                            style={{
                                'margin-top': '-10pt',
                                'margin': '0pt',
                                'padding': '0pt',
                                'fontSize': '10pt',
                                'fontWeight': 'bold',
                                'marginTop': '-10pt',
                            }}/>
                    </Button>
                </td>
               <td><Input
                   id={'given_id-' + index + '-' + childIndex}
                   value={sign.given_id}
                   onChange={(e) => this.updateSignField(index, sign, "given_id", e.target.value)}
                   onKeyDown={(e) => this.onKeyDownOnSignTextField(e, index, childIndex)}
                   /></td>
               <td><SimpleDropdown index={all_types.findIndex((x) => {
                   return x.id === sign.type.id &&
                        x.label.replace(/ Outdated$/, '') === sign.type.label.replace(/ Outdated$/, '') &&
                        x.small_size_cost === sign.type.small_size_cost &&
                        x.medium_size_cost === sign.type.medium_size_cost &&
                        x.large_size_cost === sign.type.large_size_cost
               })}
                   values={all_types.map((x) => x.label)}
                   onChange={(i) => this.updateSignField(index, sign, 'type', all_types[i])}/></td>
               {true ?
                   <td><Button onClick={(e) => {
                       this.hideCustomAddons("" + index + "-" + childIndex, isTopBar)
                   }}>Addons</Button>
                   </td>
                   :
                   <>
               <td><AddDropDownView sign={sign} addons={this.state.all_addons[sign.type.id]}
                       onChange={(addon) => this.updateAdds(index, childIndex, addon)} /></td>
               <td><Button onClick={(e) => this.popUpCustomAddonsModal(index)} >Custom</Button></td>
                   </>
               }
               <td><NumberTextField
                   showDigitsKeyPad={this.state.account.settings.numbers_calculator_show}
                   style={{
                       'textAlign': 'right',
                   }}
                   id={'width-' + index + '-' + childIndex}
                   onKeyDown={(e) => this.onKeyDownOnSignTextField(e, index, childIndex)}
                   value={sign.width} onChange={(e) => this.updateSignField(index, sign, "width", e.target.value)}/></td>
               <td><NumberTextField
                   showDigitsKeyPad={this.state.account.settings.numbers_calculator_show}
                   style={{
                       'textAlign': 'right',
                   }}
                   id={'height-' + index + '-' + childIndex}
                   onKeyDown={(e) => this.onKeyDownOnSignTextField(e, index, childIndex)}
                   value={sign.height}
                   onChange={(e) => this.updateSignField(index, sign, "height", e.target.value)}/></td>
               <td><NumberTextField
                   showDigitsKeyPad={this.state.account.settings.numbers_calculator_show}
                   style={{
                       'textAlign': 'right',
                   }}
                   id={'quantity-' + index + '-' + childIndex}
                   onKeyDown={(e) => this.onKeyDownOnSignTextField(e, index, childIndex)}
                   value={sign.quantity} onChange={(e) => this.updateSignField(index, sign, "quantity", e.target.value)}/></td>
               <td className="text-right"><Label><span text={moneyText(sign.squareInchPriceIncludingSubsigns())}>{formatAsDollarValue(sign.squareInchPriceIncludingSubsigns())}</span></Label></td>
               <td className="text-right"><Label><span text={moneyText(sign.unitPriceIncludingSubsigns())}>{formatAsDollarValue(sign.unitPriceIncludingSubsigns())}</span></Label></td>
               <td className="text-right"><Label><span text={moneyText(sign.totalPriceIncludingSubsigns())}>{formatAsDollarValue(sign.totalPriceIncludingSubsigns())}</span></Label></td>
                {childIndex > -1 ? <></> : <>
                <td>
                    {sign.subsigns.length > 0 ?
                        <Button
                            color="secondary"
                            onClick={(e) => {
                                this.setState((state) => {
                                    const minimized_subsigns = state.minimized_subsigns.includes(index)
                                        ? state.minimized_subsigns.filter((x) => x !== index)
                                        : [...state.minimized_subsigns, index]
                                    return { minimized_subsigns }
                                })
                            }} >
                                {this.state.minimized_subsigns.includes(index) ?
                                    <IoIosArrowUp
                                        style={{
                                            'fontWeight': '900',
                                        }}/> :
                                    <IoIosArrowDown
                                        style={{
                                            'fontWeight': '900',
                                        }}/>
                                }
                        </Button>
                        : <></>
                    }
                </td>
               <td><Button
                    color="primary"
                    style={{
                        'minWidth': '150px',
                    }}
                    onClick={(e) => {
                        const quote = this.state.quote
                        const sign = new Sign()
                        sign.given_id = this.getGivenIdOfNewSign(
                            index, quote.signs[index].subsigns.length > 0 ?
                                quote.signs[index].subsigns.length - 1:
                                -1
                        )
                        sign.quantity = 1
                        quote.signs[index].appendSubsigns(sign)

                        const minimizedSubsigns = this.state.minimized_subsigns
                        if (!minimizedSubsigns.includes(index)) {
                            minimizedSubsigns.push(index)
                        }

                        this.setState({
                            'quote': quote,
                            'minimized_subsigns': minimizedSubsigns,
                        })
                        this.hideCustomAddons()
                   }} >Add Sub Part</Button></td>
                </>
                }
               <td
                style={{
                    'min-width': '160px',
                }}
                ><Button
                   className='btn btn-copy'
                   onClick={(e) => {
                       const localSettings = LocalSettings.fromStorage()
                       localSettings.copySign(sign)
                       this.setState({})
                   }} >Copy Clip Board</Button></td>
               <td
                style={{
                    'min-width': '136px',
                }}
                ><Button
                   className='btn btn-copy'
                   onClick={(e) => {
                       this.hideCustomAddons()
                       this.copySign(index, childIndex)
                   }} >Duplicate</Button></td>
               <td><Button color="danger" onClick={(e) => {
                   this.hideCustomAddons()
                   this.deleteSign(index, childIndex)
               }} >Delete</Button></td>
        </tr>
            {this.state.addonsIndexShow !== ("" + index + "-" + childIndex) ? <></> :
                <tr
                    className="subtables"
                    id="currentaddonbox" >
                    <td colspan="10">
                        {this.makeAddonsRow(sign, index, childIndex)}
                    </td>
                </tr>
            }
        </>

        if (isTopBar || indexLevel > 0) {
            return tablerow
        }
        return <React.Fragment key={sign.id || ('new-' + index)}>
            {tablerow}
            {sign.subsigns.length > 0 &&
                    this.state.minimized_subsigns.includes(index) ?
                <tr
                    className="subtables"
                >
                    <td colspan={'' + (indexLevel)}></td>
                    <td colspan="12">
                        {sign.subsigns.map((subsign, subIndex) => {
                            return this.makeRow(
                                subsign, index, allowForFloatingTop,
                                subIndex, indexLevel+1,
                            )
                        })}
                    </td>
                </tr>
            : <></>}
        </React.Fragment>
    }

    makeRows() {
        if (this.state.quote) {
            return this.state.quote.signs.map((sign, index) =>
                this.makeRow(sign, index)
            )
        }
        return <></>
    }

    renderHeader(label, var_name, body) {

        return <Col>
            <div className="header-label">
                <Label className="label-weight">{label}</Label>
                {body}
            </div>
        </Col>
    }

    renderHeaderTextField(label, var_name) {

        return this.renderHeader(label, var_name,
            this.state.quote == null ? <></> :
            <Input value={this.state.quote[var_name]}
            onChange={(e) => {
                if (var_name === 'given_id') {
                    this.setState({
                        'quote_number_changed': true,
                    })
                }
                const quote = this.state.quote
                quote[var_name] = e.target.value
                this.setState({
                    quote: quote
                })
            }}/>
        )
    }

    renderHeaderDateTextField(label, var_name) {
        return this.renderHeader(label, var_name,
            this.state.quote == null ? <></> :
            <>
                <br/>
                <DateTextField
                    value={this.state.quote[var_name]}
                    showModal={this.props.showModal}
                    closeModal={this.props.closeModal}
                    onChange={(date) => {
                        const quote = this.state.quote
                        quote[var_name] = date
                        if (var_name === 'quote_date' &&
                            !this.state.quote_number_changed) {
                            quote.autogenQuoteNumber()
                        }
                        this.setState({
                            quote: quote
                        })
                    }} />
            </>
        )
    }

    renderHeaderTextFieldDropDown(label, var_name) {

        return this.renderHeader(label, var_name,
            this.state.quote == null ? <></> :
            <DropDownTextField value={this.state.quote[var_name]}
            values={this.state.customerNames}
            onChange={(e) => {
                const quote = this.state.quote
                quote[var_name] = e.target.value
                if (var_name === 'customer_name') {
                    if (!this.state.quote_number_changed) {
                        quote.autogenQuoteNumber()
                    }
                    this.updateCustomerNameDropDown(e.target.value)

                }
                this.setState({
                    quote: quote
                })
            }}
            onClickRow={(value, index) => {
                const quote = this.state.quote
                quote[var_name] = value
                if (!this.state.quote_number_changed) {
                    quote.autogenQuoteNumber()
                }
                this.setState({
                    quote: quote
                })
                if (var_name === 'customer_name') {
                    this.updateCustomerNameDropDown(value)
                    this.fillInBlankFieldsWithCustomerName(value)
                }
            }} />
        )
    }

    renderAdjustmentsColumn(label, index, varName) {
        return <Col>
            <Label>{label}</Label>
            {
                !this.state.quote ? <></> :
                <NumberTextField
                   showDigitsKeyPad={varName !== 'label' &&
                       this.state.account.settings.numbers_calculator_show}
                    style={{
                    }}
                    value={this.state.quote.adjustments[index][varName]}
                    onChange={(e) => {
                        const quote = this.state.quote
                        quote.adjustments[index][varName] = e.target.value
                        this.setState({
                            'quote': quote,
                        })
                    }} />
            }
        </Col>
    }

    renderAdjustments() {
        if (!this.state.quote) { return <></> }
        return this.state.quote.adjustments.map((adjustment, index) => {
            return <Row style={{'marginLeft':'0pt'}}>
                {this.renderAdjustmentsColumn('Label', index, 'label')}
                {this.renderAdjustmentsColumn('Percent', index, 'percent')}
                {this.renderAdjustmentsColumn('Dollar', index, 'dollar')}
                <Col><Button color="danger" 
                    style={{
                        'marginTop': '33px',
                    }}
                onClick={(e) => {
                    const quote = this.state.quote
                    quote.adjustments.splice(index, 1)
                    this.setState(function(state, props) {
                        return {
                            quote: quote
                        }
                    })
                }} >Delete</Button></Col>
            </Row>
        })
    }

    renderASGContactInfo(label, varName) {
        return <Col>
            <Label>{label}</Label>
            {
                !this.state.quote ? <></> :
                varName === 'first_name' ?
                <DropDownTextField
                    value={this.state.quote.asante_contact_info[varName]}
                    values={this.state.asanteContactInfos.map((v, i) =>
                        v.first_name + ' ' + v.last_name + ' ' + v.email + ' count ' + v.count)}
                    onChange={(e) => {
                        const quote = this.state.quote
                        quote.asante_contact_info[varName] = e.target.value
                        this.setState({
                            quote: quote,
                        })

                        getAsanteContactInformation(e.target.value).then(
                            (result) => {
                                this.setState({
                                    'asanteContactInfos': result.data.info,
                                })
                            },
                            (error) => {
                                this.props.showError(error)
                            }
                        )
                    }}
                    onClickRow={(value, index) => {
                        const quote = this.state.quote
                        quote.asante_contact_info = this.state.asanteContactInfos[index]
                        delete quote.asante_contact_info['count']
                        this.setState({
                            quote: quote
                        })

                    }} />
                :
                <Input style={{
                    }}
                    value={this.state.quote.asante_contact_info[varName]}
                    onChange={(e) => {
                        const quote = this.state.quote
                        quote.asante_contact_info[varName] = e.target.value
                        this.setState({
                            'quote': quote,
                        })
                    }} />
            }
        </Col>
    }

    renderAsanteContactInfo() {
        if (!this.state.account.hasRole(Roles.Asante)) {
            return <></>
        }

        return <Row style={rowStyle}>
            <Col>
                <Container style={{
                    'marginLeft': '23px',
                    'maxWidth': '655px',
                }}><Row><Col>
                        <Label style={{
                            'fontSize': '20pt', 'fontWeight': '400'
                        }}>Asante Sign Group Contact Information</Label>
                    </Col></Row>
                    <Row style={{'marginLeft': '0px'}}>
                        {this.renderASGContactInfo('First Name', 'first_name')}
                        {this.renderASGContactInfo('Last Name', 'last_name')}
                    </Row>
                    <Row style={{'marginLeft': '0px'}}>
                        {this.renderASGContactInfo('Email', 'email')}
                    </Row>
                </Container>
            </Col>
        </Row>
    }

    render() {
        return (
            <Container style={{
                'paddingTop': '50px',
            }}>
                {this.state.account.settings.sign_editing_top &&
                    this.state.addonsIndexShow >= 0 &&
                    this.state.addonsIndexShow < this.state.quote.signs.length?

                <Row style={rowStyle}><Col><div style={{'overflowX': 'auto'}}><Table>
                    {this.makeRow(
                        this.state.quote.signs[this.state.addonsIndexShow],
                        this.state.addonsIndexShow, true
                    )}
                    </Table></div></Col></Row>: <></>}
                <Row style={rowStyle}>
                    <Col>
                        {this.props.breadCrumbs(0, this.props.id)}
                    </Col>
                </Row>
                <Row style={rowStyle}>
                    <Col>
                        <a href="/api/file/global/quote-instructions/quote-instructions.pdf" target="_blank" rel="noreferrer">
                            Need Help Quoting?
                        </a>
                    </Col>
                </Row>
                {this.renderSuggestQuote()}
                <Row xs="2" sm={this.state.account.hasRole(Roles.Asante) ? "4" : "3"} style={rowStyle}>
                    {this.renderHeaderTextField('Job Name', 'job_name')}
                    {!this.state.account.hasRole(Roles.Asante) ? <></> : this.renderHeaderTextFieldDropDown('Customer Name', 'customer_name')}
                    {this.renderHeaderTextField('Quote Number', 'given_id')}
                    {this.renderHeaderDateTextField('Date', 'quote_date')}
                </Row>
                <Row style={rowStyle}><Col><div style={{'overflowX': 'auto'}}><Table>
                    <thead>
                        <tr>
                            {
                                false && this.state.quote &&
                                this.state.quote.hasAddonThatCanBeUpgraded(
                                    this.state.all_addons) ?
                                <th
                                    className="text-center label-weight"
                                    style={{'minWidth': '200px'}}
                                >Upgrade Addons</th>
                                : <></>
                            }
                            <th className="text-center label-weight"></th>
                            <th className="text-center label-weight" style={{'minWidth': '200px'}}>Sign Type</th>
                            <th className="text-center label-weight" style={{'minWidth': '60px'}}>Process</th>
                            {true ? 
                            <th className="text-center label-weight" style={{'minWidth': '60px'}}>Adds</th>
                                :
                                <>
                            <th className="text-center label-weight" style={{'minWidth': '60px'}}>Adds</th>
                            <th className="text-center label-weight" style={{'minWidth': '60px'}}>Custom Addons</th>
                                </>
                            }
                            <th className="text-center label-weight" style={{'minWidth': '100px'}}>Width</th>
                            <th className="text-center label-weight" style={{'minWidth': '100px'}}>Height</th>
                            <th className="text-center label-weight" style={{'minWidth': '60px'}}>Quantity</th>
                            <th className="text-center label-weight" style={{'minWidth': '60px'}}>Sq Inch Price</th>
                            <th className="text-center label-weight" style={{'minWidth': '60px'}}>Unit Price</th>
                            <th className="text-center label-weight" style={{'minWidth': '60px'}}>Total Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.makeRows()}
                        <tr>
                            <td/><td/><td/><td/><td/><td/>
                            <td style={{
                                'textAlign': 'right',
                            }}><Label style={{
                                'marginRight': '13px',
                            }}>{this.state.quote ? this.state.quote.totalSignCount() : 0}</Label></td>
                            <td/><td/>
                            <td style={{
                                'textAlign': 'right',
                            }}><Label >{(() => {
                                const total = this.state.quote ? this.state.quote.totalCost() : 0.00
                                return <span text={moneyText(total)}>{formatAsDollarValue(total)}</span>
                            })()}</Label></td>
                        </tr>
                    </tbody>
                </Table></div></Col></Row>
                <Row style={rowStyle}>
                    <Col>
                        <Container style={{'paddingRight': '24px', 'textAlign': 'right'}}>
                            <Button disabled={!this.state.quote} color='success' onClick={(e) => {
                                this.hideCustomAddons("-1--1", true)
                                this.appendSign()
                            }}>Add Sign</Button>
                            {
                                LocalSettings.fromStorage().copied_signs.length > 0?
                            <Button disabled={!this.state.quote} color='success' onClick={(e) => {
                                const localSettings = LocalSettings.fromStorage()
                                const signs = localSettings.pasteSigns()
                                if (signs.length > 0) {
                                    this.hideCustomAddons("-1--1", true)

                                    const quote = this.state.quote
                                    for (let i = 0; i < signs.length; i++) {
                                        quote.signs.push(signs[i])
                                    }

                                    this.setState({
                                        quote: quote
                                    })
                                }
                            }} style={{
                                'marginLeft': '10px',
                            }}>Paste Signs</Button>
                            : <></>
                            }
                        </Container>
                    </Col>
                </Row>
                <Row style={rowStyle}>
                    <Col>
                        <Container style={{
                            'marginLeft': '23px',
                            'maxWidth': '655px',
                        }}><Row><Col>
                                <Label style={{
                                    'fontSize': '20pt', 'fontWeight': '400'
                                }}>Adjustments</Label>
                            </Col></Row>
                            {this.renderAdjustments()}
                            <Button
                                color='success'
                                style={{
                                    'margin': '8px',
                                    'float': 'right',
                                }}
                                onClick={(e) => {
                                    const quote = this.state.quote
                                    quote.addAdjustment()
                                    this.setState({
                                        'quote': quote,
                                    })
                                }}
                                    >Add Adjustment</Button>
                        </Container>
                    </Col>
                </Row>
                <Row style={rowStyle}>
                    <Col>
                        <Container style={{
                            'marginLeft': '23px',
                            'maxWidth': '655px',
                        }}><Row><Col>
                                <Label style={{
                                    'fontSize': '20pt', 'fontWeight': '400'
                                }}>Shipping</Label>
                            </Col></Row>
                            { this.state.quote ?
                            <Row style={{'marginLeft':'0pt'}}>
                                <Col>
                                    <NumberTextField
                                        showDigitsKeyPad={this.state.account.settings.numbers_calculator_show}
                                        value={this.state.quote.shipping_cost}
                                        onChange={(e) => {
                                            const quote = this.state.quote
                                            quote.shipping_cost = e.target.value
                                            this.setState({
                                                'quote': quote,
                                            })
                                        }} />
                                </Col>
                            </Row>
                                : <></>
                            }
                        </Container>
                    </Col>
                </Row>
                {this.renderAsanteContactInfo()}
                <Row style={rowStyle}>
                    <Col>
                        <Container style={{'maxWidth': '700px', 'marginLeft': '8px'}}>
                            {
                                this.state.quote == null ? <></> :
                                <ContactInformationViewController
                                    model={this.state.quote.contact_info}
                                    onUpdate={(fieldName, value) => {
                                        this.updateSubQuoteField('contact_info', fieldName, value)
                                        this.updateFirstNameDropDown(this.state.quote.customer_name, this.state.quote.contact_info.first_name)
                                    }}
                                    firstNames={this.state.firstNamesQuotes.map((item, index) =>
                                        item.contact_info.first_name + ' ' + item.contact_info.last_name + ' ' + item.count)}
                                    onClickRow={(varName, value, index) => {
                                        this.updateFirstNameDropDown(this.state.quote.customer_name, this.state.quote.contact_info.first_name)
                                        this.fillInBlankFields(this.state.firstNamesQuotes[index])
                                    }}

                                />
                            }
                        </Container>
                    </Col>
                </Row>
                <br />
            {
                // <Row style={rowStyle}>
                //     <Col>
                //         <Container style={{'paddingLeft': '48px'}}>
                //             <Button
                //                 onClick={(e) => this.copyContactInfoToShippingAddr()}
                //                 >Copy Contact Information to Shipping Address</Button>
                //         </Container>
                //     </Col>
                // </Row>
                // <br />
                // <Row style={rowStyle}>
                //     <Col>
                //         <Container style={{'maxWidth': '700px', 'marginLeft': '8px'}}>
                //             {
                //                 this.state.quote == null ? <></> :
                //                 <AddressViewController
                //                     model={this.state.quote.shipping_info}
                //                     onUpdate={(fieldName, value) =>
                //                         this.updateSubQuoteField('shipping_info', fieldName, value)} />
                //             }
                //         </Container>
                //     </Col>
                // </Row>
            }
                <Row style={rowStyle}>
                    <Col>
                        <Container style={{'maxWidth': '700px', 'marginLeft': '8px', 'marginTop': '8px'}}>
                            <Row>
                                <Col>
                                    <Container>
                                        <Label style={{'fontSize': '20pt', 'fontWeight': '400'}}>Additional Comments</Label>
                                    </Container>
                                </Col>
                            </Row>
                                <Col>
                                    <Container>
                                    {
                                        this.state.quote != null ?
                                            <Input
                                                type="textarea"
                                                value={this.state.quote.comments} onChange={(e) => this.updateComments(e.target.value)}
                                                style={{'width': '100%', 'height': '200px'}} />
                                            :
                                            <></>
                                    }
                                    </Container>
                                </Col>
                        </Container>
                    </Col>
                </Row>
                {
                    this.state.account.settings.import_export_sign_json && this.state.quote
                    ? <>
                        <Row>
                            <Col>
                                <Label style={{
                                    'fontSize': '20pt', 'fontWeight': '400'
                                }}>Import Signs JSON</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label style={{
                                    'fontSize': '13pt', 'fontWeight': '400'
                                }}>Current</Label>
                            </Col>
                            <Col>
                                <Label style={{
                                    'fontSize': '13pt', 'fontWeight': '400'
                                }}>New Signs</Label>
                                <Button className="sm" onClick={() => {
                                    const quote = Quote.from({'signs': JSON.parse(this.state.new_signs_json)})
                                    let quoteState = this.state.quote
                                    quoteState.signs = quote.signs
                                    this.setState({})
                                }}>Update</Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Input
                                    type="textarea"
                                    value={JSON.stringify(this.state.quote.signs)}
                                    style={{'width': '100%', 'height': '200px'}} />
                            </Col>
                            <Col>
                                <Input
                                    type="textarea"
                                    value={this.state.new_signs_json}
                                    style={{'width': '100%', 'height': '200px'}} 
                                    onChange={(e) => this.setState({'new_signs_json': e.target.value})}
                                    />
                            </Col>
                        </Row>
                    </>
                    :<></>
                }
                <Row
                    className='quote-bottom-bottons-row'
                    xs="1" sm="4">
                    <Col>
                        <Container>
                            <Button disabled={!this.state.quote} color="success" onClick={(e) => this.saveQuote()}
                                size="lg" className="default-weight purchase-button" >Save Quote</Button>
                        </Container>
                    </Col>
                    <Col>
                        <Container>
                            <Button color="secondary" onClick={(e) => this.downloadAndViewPDF()}
                                size="lg" className="default-weight purchase-button" >Download PDF</Button>
                        </Container>
                    </Col>
                    <Col>
                        <Container>
                            <Button color="warning" onClick={(e) => this.popUpPackagingSlipModal()}
                                size="lg" className="default-weight purchase-button" >Packaging Slip</Button>
                        </Container>
                    </Col>
                    <Col>
                        <Container>
                            <Button
                                color="info"
                                onClick={(e) => this.popUpEmailModal()}
                                size="lg" className="default-weight purchase-button" >Send PDF as Email</Button>
                        </Container>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default QuoteViewController
